import { DataTable } from '@components/Table/DataTable';
import { TableHeaderCell } from '@components/Table/TableHeaderCell';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { TableBody, TableCell, TableContainerProps, TableHead, TableRow } from '@material-ui/core';
import { useVendedorComissaoTipoColor } from '@model/VendedorComissao';
import { IVendedorComissaoFilter, IVendedorComissaoRecord } from '@services/VendedorComissaoService';
import React from 'react';

export type FichaVendedorComissaoTableProps = {
    isLoading: boolean
    data: IData<IVendedorComissaoRecord, IVendedorComissaoFilter>
    tableContainerProps?: TableContainerProps
}

export function FichaVendedorComissaoTable ({isLoading, data, tableContainerProps}: FichaVendedorComissaoTableProps) {
    const formatter = useFormatter();
    const vendedorComissaoTipoColor = useVendedorComissaoTipoColor();

    return (
        <React.Fragment>
            <DataTable 
                isLoading={isLoading} 
                itemCount={data.itemsCount}
                tableContainerProps={tableContainerProps}
            >
                <TableHead>
                    <TableRow>
                        <TableHeaderCell>ID</TableHeaderCell>
                        <TableHeaderCell>Data/Hora</TableHeaderCell>
                        <TableHeaderCell>Competência</TableHeaderCell>
                        <TableHeaderCell>Descrição</TableHeaderCell>
                        <TableHeaderCell>Contrato</TableHeaderCell>
                        <TableHeaderCell>Empresa</TableHeaderCell>
                        <TableHeaderCell>Tipo</TableHeaderCell>
                        <TableHeaderCell>Valor</TableHeaderCell>
                        <TableHeaderCell>Saldo</TableHeaderCell>
                    </TableRow>
                </TableHead>
                
                <TableBody>
                    {
                        data.items.map((vendedorComissao, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableKeyCell>{vendedorComissao.vendedorComissaoId || ''}</TableKeyCell>
                                    <TableCell>{vendedorComissao.dataHora !== undefined ? formatter.toDateTime(vendedorComissao.dataHora) : ''}</TableCell>
                                    <TableCell>{formatter.toCompetencia(vendedorComissao.competencia)}</TableCell>
                                    <TableCell>{vendedorComissao.descricao}</TableCell>
                                    <TableCell>{vendedorComissao.contratoClienteId || ''}</TableCell>
                                    <TableCell>{vendedorComissao.empresa?.nome || ''}</TableCell>
                                    <TableCell className={vendedorComissao.tipo?.value !== undefined ? vendedorComissaoTipoColor[vendedorComissao.tipo.value] : ''}>{vendedorComissao.tipo?.description}</TableCell>
                                    <TableCell>{formatter.toFloat(vendedorComissao.valor)}</TableCell>
                                    <TableCell>{formatter.toFloat(vendedorComissao.saldo)}</TableCell>
                                </TableRow>
                            )
                        })
                    }
                </TableBody>
            </DataTable>
        </React.Fragment>
    )
}